import React, { useEffect } from 'react';
import {
  RFQ_PROPOSAL_CARD_DATA,
  getRFQProposalChecklistURL,
} from 'global/checklists-helpers/RFQProposalChecklistHelper';
import { observer } from 'mobx-react-lite';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { useHistory } from 'react-router-dom';
import { useBrokerMessagePageStore } from 'store/pages/rfq/rfq-response/broker-message/pageStore';
import useRfqQuoteUrlParams from 'global/hooks/useRfqQuoteUrlParams';
import PageFooter from 'components/common/general/layouts/PageFooter';
import RoundedWrapper from 'components/common/rfq/RoundedWrapper';
import { AnswersListStyled, ItemStyled, ItemTitleStyled, ItemValueStyled, TitleStyled } from './styles';
import { BROKER_MESSAGE_ANSWERS_TEST_ID } from '../constants';

const BrokerMessageContent: React.FC = observer(() => {
  const history = useHistory();
  const { periodId, cartId } = useRfqQuoteUrlParams();

  const { isLoading, initiateAnswers, getInitialData } = useBrokerMessagePageStore();

  useEffect(() => {
    void getInitialData(periodId, cartId);
  }, []);

  const onDefaultRedirect = (): void => {
    history.push(getRFQProposalChecklistURL({ periodId, cartId }));
  };

  return (
    <>
      <PageHeader
        title={RFQ_PROPOSAL_CARD_DATA.BROKER_MESSAGE.title}
        subtitle={RFQ_PROPOSAL_CARD_DATA.BROKER_MESSAGE.text}
        subtitleMaxWidth="70%"
        onRedirect={onDefaultRedirect}
      />
      <RoundedWrapper loading={isLoading} minHeight="25rem">
        <TitleStyled>Broker Information</TitleStyled>
        <AnswersListStyled data-test-id={BROKER_MESSAGE_ANSWERS_TEST_ID}>
          {Object.entries(initiateAnswers).map(([key, value]) => (
            <ItemStyled key={key}>
              <ItemTitleStyled>{key}</ItemTitleStyled>
              <ItemValueStyled>{value}</ItemValueStyled>
            </ItemStyled>
          ))}
        </AnswersListStyled>
      </RoundedWrapper>

      <PageFooter onBack={onDefaultRedirect} backButtonText="Back to checklist" />
    </>
  );
});

export default BrokerMessageContent;
